import {LOOKUP_ENUM} from "../../dictionary/core/lookup.enum";
export const ORDER_STATUS = LOOKUP_ENUM.ORDER_STATUS;
